import React, { useState } from 'react'
import { Button, Dropdown, Form, Modal } from 'react-bootstrap'
import {
  IVacancyCompany,
  VacancyCompanyHook
} from "../../../api/vacancy-company/vacancy-company.api";
import {toast} from "react-toastify";

type Props = {
  vacancyCompany: IVacancyCompany
  update:() => void
}

export const RemoveVacancyCompany = ({update, vacancyCompany}: Props) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  }
  const { mutate: DeleteMutate } = VacancyCompanyHook.useDeleteVacancyCompanies()

  const handleForm = (e: React.FormEvent) => {
    e.preventDefault();

    DeleteMutate(Number(vacancyCompany.id), {
      onSuccess: () => {
        toast.success("Заказчик успешно удален!");
        update()
        handleClose();
      },
      onError: (error) => {
        toast.error(`Ошибка при удалении: ${error.message}`);
      },
    });
  }


  return <>
    <Dropdown.Item onClick={handleShow} >
      Удалить
    </Dropdown.Item>

    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Удаление: {vacancyCompany?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
           <p className={'text-danger mb-2'}>Вы точно хотите удалить заказчика?</p>
          <Button onClick={handleForm} variant="danger" type="submit">Удалить</Button>
        </Form>
      </Modal.Body>

    </Modal>
  </>
}